import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageTitle, PseudoStates, ErrorBoundary } from '@cordata/buffet';

import { Form } from '~/components/CareGiver';

import { store } from '~/utils/care-giver';

const PatientsCareGiverDetails = () => {
  const { id, ...p } = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();

  useEffect(() => {
    if (id !== 'add') {
      store.getOne(id, { patient: p.patient_id })
        .then(setData)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setData();
      setStatus('success');
    }
  }, [id]);

  if (status !== 'success') {
    return <PseudoStates status={status} />;
  }

  return (
    <>
      <PageTitle>
        Care Giver
      </PageTitle>

      <ErrorBoundary>
        <Form
          data={{
            ...data,
          }}
        />
      </ErrorBoundary>
    </>
  );
};

export default PatientsCareGiverDetails;
